<template>
  <el-dialog
    :visible.sync="show"
    size="100%"
    :with-header="false"
    destroy-on-close
    fullscreen
    :show-close="false"
    custom-class="memoModal"
  >
    <div class="note">
      <div
        class="header"
        :style="{
          padding: $isElectron ? '40px 0' : '10px 0',
        }"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="cancelButtonClicked"
          style="cursor: pointer"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.954 0.849705C14.0332 0.928666 14.096 1.02247 14.1388 1.12574C14.1817 1.22901 14.2037 1.33972 14.2037 1.45153C14.2037 1.56334 14.1817 1.67405 14.1388 1.77732C14.096 1.88059 14.0332 1.97439 13.954 2.05335L2.05352 13.9538C1.8939 14.1134 1.67742 14.2031 1.45169 14.2031C1.22597 14.2031 1.00948 14.1134 0.849869 13.9538C0.690256 13.7942 0.600586 13.5777 0.600586 13.352C0.600586 13.1263 0.690256 12.9098 0.849869 12.7502L12.7503 0.849705C12.8293 0.770544 12.9231 0.707739 13.0264 0.664886C13.1296 0.622033 13.2404 0.599976 13.3522 0.599976C13.464 0.599976 13.5747 0.622033 13.678 0.664886C13.7812 0.707739 13.875 0.770544 13.954 0.849705Z"
            fill="#9D9D9D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.849827 0.849705C0.770666 0.928666 0.707861 1.02247 0.665008 1.12574C0.622155 1.22901 0.600098 1.33972 0.600098 1.45153C0.600098 1.56334 0.622155 1.67405 0.665008 1.77732C0.707861 1.88059 0.770666 1.97439 0.849827 2.05335L12.7503 13.9538C12.9099 14.1134 13.1264 14.2031 13.3521 14.2031C13.5778 14.2031 13.7943 14.1134 13.9539 13.9538C14.1136 13.7942 14.2032 13.5777 14.2032 13.352C14.2032 13.1263 14.1136 12.9098 13.9539 12.7502L2.05347 0.849705C1.97451 0.770544 1.88071 0.707739 1.77744 0.664886C1.67417 0.622033 1.56346 0.599976 1.45165 0.599976C1.33984 0.599976 1.22913 0.622033 1.12586 0.664886C1.02259 0.707739 0.928788 0.770544 0.849827 0.849705Z"
            fill="#9D9D9D"
          />
        </svg>

        <h2>{{ $t('components.FullscreenEditor.title') }}</h2>
        <span></span>
      </div>
      <fl-editor
        id="fl_editor"
        ref="fl_editor"
        :initContent="memo?.content"
        :initFiles="memo?.files"
        :autoFocus="true"
        draftKey="draft:new"
        v-on:memo-updated="newMemoCreated"
        apiEndPoint="/api/memo/"
        :placeholder="$t('memo.placeholder')"
        v-on:cancel-button-clicked="cancelButtonClicked"
        :memo_slug="memo?.slug"
      ></fl-editor>
    </div>
  </el-dialog>
</template>
<script>
import FlEditor from '../pages/FlEditor.vue'
import DBUtil from '../utils/DBUtil'
export default {
  name: 'full-screen-editor',
  components: {
    FlEditor,
  },
  data() {
    return {
      memo: null,
    }
  },
  computed: {
    show() {
      return this.$store.getters['fullscreenEditor/show']
    },
    dailyReviewList() {
      return this.$store.getters['dailyReview/dailyReviewList']
    },
    progress() {
      return this.$store.getters['fullscreenEditor/progress']
    },
  },

  methods: {
    async newMemoCreated(memo) {
      await this.$store.dispatch('dailyReview/setCurrentReviewMemo', memo)
      await this.$store.dispatch('fullscreenEditor/hide')
      //await this.$store.dispatch('dailyReview/getCurrentReviewMemo')
      this.memo = null
    },
    async getMemo(slug) {
      this.memo = await DBUtil.getMemo(slug)
      this.$refs.fl_editor.editor.commands.setContent(this.memo.content)
      this.$refs.fl_editor.editor.commands.focus()
      this.$refs.fl_editor.memo = this.memo
      this.$refs.fl_editor.file_ids = this.memo.files.map(function (file) {
        return file.id
      })
      this.$refs.fl_editor.files_show = this.memo.files.length
      this.$refs.fl_editor.fileList = this.memo.files
    },
    async cancelButtonClicked() {
      await this.$store.dispatch('fullscreenEditor/hide')
      this.memo = null
    },
  },
  watch: {
    show(val) {
      if (val) {
        let progress = this.progress
        if (progress) {
          progress = progress - 1
        }
        this.getMemo(this.dailyReviewList[progress])
      }
    },
  },
}
</script>
<style lang="scss" scoped>
div.note {
  padding: 10px;
  max-width: 648px;
  max-height: 100%;
  /* overflow: auto; */
  margin: 0px 10px 20px 0;
  position: relative;
  background: (--defaultBg);
  margin: 0 auto;
}

div.note .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  height: 52px;
  box-sizing: border-box;
}

div.note .header h2 {
  font-weight: bold;
  font-size: 18px;
  /* color: #323232; */
}

div.note .header .close {
  padding: 6px;
  color: grey;
  cursor: pointer;
}
</style>
